import { useEffect, useState } from "react";
import {Form,Button} from 'reactstrap';
import { APISD } from "../../../../../../../../config/apisd";
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import LoaderAction from "../../../../../../../Loader/LoaderHome";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
  
export default function ModalTAUpdate(props) {
  const token = localStorage.getItem("token");
  const [propsData, setProopsData] = useState();
  const safeValue = (value) => value ?? "";

  const [isSubmitting, setIsSubmitting] = useState(false);
  
  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };

  const id_user = localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g, "");

  const [form, setForm] = useState({
    name_fase: "",
    description: "",
    user_id: "",
  });

  // useEffect(() => {
  //   setForm({
  //     ...form, 
  //     name_fase: `${props?.nameUpdate}`,
  //     description: `${props?.descriptionUpdate}`
  //   });
  // }, [props])

    useEffect(() => {
    setForm({
    ...form,
      name_fase: safeValue(props?.dataUpdate?.name_fase),
      description: safeValue(props?.dataUpdate?.description)
    });
  },[props])

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = useMutation(async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APISD.put(
        `/api/fases/${props.id}`,
        {
          name_fase: form?.name_fase,
          description: form?.description,
          user_id: id_user,
        },
        fetchParams
      );

      if (response.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response.data.message,
        });

        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memperbarui data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });


  return (
    <div className="modal">

     <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>  
    
            <div className="d-flex header-modal">
                <h5>Update Fase</h5>
            
                <div className="ml-auto x-close">
                    <FontAwesomeIcon icon={faXmark} onClick={() => setProopsData(props.onHide)} />
                </div>
              </div>
            <hr/>
          <Modal.Body className="modal-body">
          <Form onSubmit={(e) => handleSubmit.mutate(e)}  >
              <div className="mt-4 label-group-form" >
                <label className="label-name-form">
                 Nama Fase
                </label>
                <input className="label-input-form"  type='text' name="name_fase" onChange={handleChange} value={form?.name_fase}  
                />
                <style>{`input::placeholder { color: #B9B9B9;}`}
                </style>
              </div>

              <div className="mt-4 label-group-form" >
                <label className="label-name-form">
                 Deskripsi
                </label>
                <input className="label-input-form"  type='text' name="description" onChange={handleChange} value={form?.description}  
                 required/>
                <style>{`input::placeholder { color: #B9B9B9;}`}
                </style>
              </div>
    
            <div className="d-flex">
              <div className="ml-auto">
                <Button
                  className="mt-4 btn-modal-create"
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    borderRadius: 12,
                    padding: "8px 14px",
                    boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                  }}
                >
                  {isSubmitting ? (
                    <span>
                      <i className="fa fa-spinner fa-spin mr-2" />
                      Memperbarui...
                    </span>
                  ) : (
                    "Perbarui"
                  )}
                </Button>
              </div>
            </div>
          </Form>
            
        </Modal.Body>
    </Modal>

  </div>
    );
  }
